import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { ArrowLeft, PawPrint } from "lucide-react";

/**
 * Shared layout for policy/info pages.
 * Renders the branded header, title block, and a single Card wrapper around children.
 */
export default function PolicyLayout({ eyebrow, title, intro, children, testId }) {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border bg-card">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <img
              src="https://customer-assets.emergentagent.com/job_fetch-toy-store/artifacts/xq3326bd_Gemini_Generated_Image_sijaotsijaotsija.png"
              alt="Pawventure Essentials"
              className="w-10 h-10 rounded-full object-cover ring-1 ring-border"
            />
            <span className="font-display font-bold text-xl tracking-tight">
              Pawventure <span className="text-primary">Essentials</span>
            </span>
          </Link>
          <Link to="/">
            <Button variant="ghost" size="sm" className="rounded-full font-semibold">
              <ArrowLeft size={14} className="mr-2" strokeWidth={2.5} /> Back to shop
            </Button>
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-12 lg:py-16" data-testid={testId}>
        <div className="text-center mb-10">
          {eyebrow && (
            <span className="inline-block text-xs font-bold tracking-widest uppercase text-primary bg-primary/10 rounded-full px-3 py-1">
              {eyebrow}
            </span>
          )}
          <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight mt-4">{title}</h1>
          {intro && (
            <p className="text-muted-foreground mt-4 text-base leading-relaxed max-w-xl mx-auto">{intro}</p>
          )}
        </div>

        <Card className="rounded-3xl border-border p-7 sm:p-10 space-y-8">{children}</Card>

        <div className="mt-10 text-center">
          <Link to="/">
            <Button className="rounded-full h-12 px-8 font-bold">
              <PawPrint size={16} className="mr-2" strokeWidth={2.5} /> Back to shop
            </Button>
          </Link>
        </div>
      </main>
    </div>
  );
}

export function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-display text-xl sm:text-2xl font-bold mb-3 tracking-tight">{title}</h2>
      <div className="text-muted-foreground leading-relaxed text-base space-y-2">{children}</div>
    </section>
  );
}
